import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { handleSubmit } from './../helpers'

import {
  onChangeName, onChangeEmail, onChangeLink, onChangeAgreeFinal, onSendFormDesign
} from './../actions/app'


const FormFinal = ({ form, onChangeName, onChangeEmail, onChangeLink, onChangeAgreeFinal, onSendFormDesign }) => (
  <form onSubmit={handleSubmit}>
    <label htmlFor="name" className={form.nameIsValid}>
      *Full Name
      <input type="text" defaultValue={ form.name } onChange={ onChangeName } autoComplete='name' id="name" placeholder="Full Name" />
    </label>
    <label htmlFor="email" className={form.emailIsValid}>
      *Email
      <input type="text" defaultValue={ form.email } onChange={ onChangeEmail } autoComplete='email' id="email" placeholder="Your email here…" />
    </label>
    <label htmlFor="task0" className={form.task0IsValid}>
      *Task Link 1
      <input type="text" id="task0"  defaultValue={ form.task0 } onChange={ onChangeLink } placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="task1" className={form.task1IsValid}>
      *Task Link 2
      <input type="text" id="task1" defaultValue={ form.task1 } onChange={ onChangeLink }  placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="task2" className={form.task2IsValid}>
      *Task Link 3
      <input type="text" id="task2" defaultValue={ form.task2 } onChange={ onChangeLink }  placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="agree" onClick={ () => onChangeAgreeFinal(!form.checkedFinal) } className={form.checkedFinal ? 'checked' : ''}>
      I agree that i will do this test on the mandatory time frame, and I will not try to cheat it.
      <input type="checkbox"/>
    </label>
    <button disabled={form.disabledFinal}  onClick={onSendFormDesign}>I want to send my Designs</button>
  </form>
)

const mapStateToProps = ({ app: { form } }) => ({
  form
})
const mapDispatchToProps = dispatch => bindActionCreators({
  onChangeName, onChangeEmail, onChangeLink, onChangeAgreeFinal, onSendFormDesign
}, dispatch)

export default connect(
  mapStateToProps, mapDispatchToProps
)(FormFinal)


// WEBPACK FOOTER //
// ./src/containers/FormFinal.js